import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from '@vds/grids';

import { Title, Body } from '../../common/Typography/index';
import { RadioBoxGroup } from '../../common/RadioBox';
import { isMobile, isTablet } from '../../common/Helpers';

const AppointmentSlots = (props) => {
  const { selectedDate, availableSlots } = props;
  const defaultValue = availableSlots?.apptAvailableTime && availableSlots.apptAvailableTime.length ? availableSlots.apptAvailableTime[0] : null;
  const isDevice = isMobile() || isTablet();

  useEffect(() => {
    if (selectedDate) {
      props.saveSelectedSlot(defaultValue);
    }
  }, [selectedDate]);

  const generateAppointmentSlots = (slots) => {
    const widthValue = isDevice ? '48%' : '398px';
    const slotsArr = [];
    let slotText = '';
    if (slots && slots.apptAvailableTime) {
      slots.apptAvailableTime.forEach((slot) => {
        slotText = `${slot.startTime.split(':')[0].replace(/^0+/, '')} - ${slot.endTime.split(':')[0].replace(/^0+/, '')} ${slot.startTime
          .split(':')[1]
          .replace(/^0+/, '')}`;

        slotsArr.push({
          name: 'appointmentSlots',
          text: slotText,
          value: slot && JSON.stringify(slot),
          width: widthValue,
          disabled: !slot.isAvailable,
          dataTrack: true,
          ariaSelected: props.selectedSlot === slot,
          ariaLabel: `Between ${slot.startTime} and ${slot.endTime}`,
          analyticstrack: `5G-slot-${slot.startTime} to ${slot.endTime}`,
        });
      });
    }
    return slotsArr;
  };

  return (
    <Grid colSizes={{ mobile: 4, tablet: 10, desktop: 12 }}>
      <Row className="noPadding marginTop40">
        {props.availableSlots && (
          <Col className="noPadding">
            <Title primitive="h2" size="medium">
              {props.slotsHeading}
            </Title>
            <div className="marginTop8 marginBottom24">
              <Body primitive="p" size="large">
                {props.slotsSubHeading}
              </Body>
            </div>
            <div key={`${props.availableSlots.length}aptslot`} className='appointmentSlots'>
              <RadioBoxGroup
                defaultValue={JSON.stringify(defaultValue)}
                value={JSON.stringify(props.selectedSlot)}
                orientation="horizontal"
                data={generateAppointmentSlots(props.availableSlots)}
                onChange={(e) => props.handleSlotSelection(e.target.value)}
              />
            </div>
          </Col>
        )}
      </Row>
    </Grid>
  );
};

AppointmentSlots.propTypes = {
  selectedSlot: PropTypes.object,
  availableSlots: PropTypes.object,
  slotsHeading: PropTypes.string,
  slotsSubHeading: PropTypes.string,
  handleSlotSelection: PropTypes.func,
  saveSelectedSlot: PropTypes.func,
  selectedDate: PropTypes.string,
};

export default AppointmentSlots;
